<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="company" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_company')">
                            <b-form-select v-model="formData.company_id" :options="companyOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input v-model="formData.start_date" type="date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')">
                            <b-form-input v-model="formData.end_date" type="date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="responsible" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_posting_responsible')">
                            <staff-auto-complete v-model="formData.responsible_id" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="min_gno" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_min_gno')">
                            <b-form-input v-model="formData.min_gno" type="number" step="0.01" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="position" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_position')">
                            <b-form-input v-model="formData.position" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="location_type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_location_type')">
                            <b-form-select v-model="formData.location_type" :options="locationTypeOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="formData.status" :options="statusOptions" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <ValidationProvider name="quota" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_quota')">
                            <b-form-input v-model="formData.quota" type="number" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group :label="$t('faculty')">
                        <faculty-selectbox v-model="formData.faculty_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group :label="$t('department')">
                        <department-selectbox :faculty_code="formData.faculty_code" v-model="formData.department_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group :label="$t('class')">
                        <classes-selectbox v-model="formData.class" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="content" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_posting_content')">
                            <b-form-textarea v-model="formData.content" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="company_description" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_company_intro')">
                            <b-form-textarea v-model="formData.company_description" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="benefits" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_provided_benefits')">
                            <b-form-textarea v-model="formData.benefits" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="qualifications" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_required_qualifications')">
                            <b-form-textarea v-model="formData.qualifications" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" :disabled="formLoading" @click="update">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
    import ClassesSelectbox from '@/components/interactive-fields/ClassesSelectbox';
    import StaffAutoComplete from '@/components/interactive-fields/StaffAutoComplete';
    import CoopAdService from '@/services/CoopAdService';
    import CoopCompanyService from '@/services/CoopCompanyService';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            FacultySelectbox,
            DepartmentSelectbox,
            ClassesSelectbox,
            StaffAutoComplete
        },
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                formLoading: false,
                companyOptions: [],
                formData: {
                    company_id: null,
                    position: null,
                    start_date: null,
                    end_date: null,
                    responsible_id: null,
                    min_gno: null,
                    location_type: null,
                    quota: null,
                    faculty_code: null,
                    department_code: null,
                    class: null,
                    status: 'active',
                    content: null,
                    company_description: null,
                    benefits: null,
                    qualifications: null
                },
                statusOptions: [
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ],
                locationTypeOptions: [
                    {value: 'onsite', text: this.$t('coop_location_type_onsite')},
                    {value: 'remote', text: this.$t('coop_location_type_remote')},
                    {value: 'hybrid', text: this.$t('coop_location_type_hybrid')}
                ]
            }
        },
        created() {
            CoopCompanyService.getAll({params: {filter: {}, page: 1, limit: 1000}}).then((response) => {
                this.companyOptions = response.data.data.map((company) => ({
                    value: company.id,
                    text: company.name
                }));
            });
            this.get(this.formId);
        },
        methods: {
            get(id) {
                CoopAdService.get(id)
                    .then(response => {
                        this.formData = response.data.data;
                    })
                    .catch((error) => {
                        this.showErrors(error, null);
                    });
            },
            async update() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    CoopAdService.update(this.formId, this.formData)
                        .then(response => {
                            this.$toast.success(this.$t(response.data.message));
                            this.$emit('actionSuccess', true);
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    }
</script>
